import { injectIntl, IntlShape } from 'react-intl';
import { Listings } from 'containers/AppContainer/typings';

import { get, isEmpty, isNil } from 'lodash';

import RegulationTable from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationTable';
import RegulationRecapPage from 'containers/CourtManagerLegalProceedings/Provision/Regulation/RegulationRecapPage';
import { useEffect, useState } from 'react';

export interface RegulationTableProps {
  intl: IntlShape;
  sagisClaim: any;
  listings: Listings;
  regulations: any;
  isConsultation: boolean;
  isRecap?: boolean;
  paymentIdPath?: string;
  claimId: number;
  isBasicManagementRegulation?: boolean;
}

export const RegulationRecapContainer: React.FC<RegulationTableProps> = ({
  sagisClaim,
  regulations,
  listings,
  isConsultation,
  isRecap,
  paymentIdPath,
  claimId,
  ...props
}): JSX.Element => {
  const [paymentId, setPaymentId] = useState(
    paymentIdPath ? paymentIdPath : '',
  );
  const [openRecap, setOpenRecap] = useState(isRecap);
  const allRegulations = [
    ...(get(sagisClaim, 'regulations', []) || []),
    ...(get(sagisClaim, 'contractorFees', []) || []).flatMap(
      (item: any) => item.regulations,
    ),
  ];

  const handlePaymentId = (id: string) => {
    setPaymentId(id);
  };

  const handleOpenRecap = (isOpen: boolean) => {
    setOpenRecap(isOpen);
  };
  /* istanbul ignore next */
  useEffect(() => {
    if (!isNil(paymentIdPath)) {
      setOpenRecap(isRecap);
      setPaymentId(paymentIdPath);
    }
  }, [paymentIdPath, isRecap]);

  return (
    <>
      {!isEmpty(allRegulations) &&
        (!openRecap ? (
          <div>
            <RegulationTable
              {...props}
              allRegulations={allRegulations}
              sagisClaim={sagisClaim}
              listings={listings}
              regulations={regulations}
              isConsultation={isConsultation}
              setOpenRecap={handleOpenRecap}
              setPaymentId={handlePaymentId}
            />
          </div>
        ) : (
          <RegulationRecapPage
            {...props}
            setOPenRecap={handleOpenRecap}
            match={{
              params: {
                paymentId: parseInt(paymentId),
                claimId: claimId,
              },
            }}
            isConsultation={isConsultation}
            isRecap={true}
            isBasicManagementRegulation={props.isBasicManagementRegulation}
          />
        ))}
    </>
  );
};

export default injectIntl(RegulationRecapContainer);
